import React from 'react'
import BillPayNeedsApproval from 'src/app/BillPayNeedsApproval/BillPayNeedsApproval'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { billPayNeedsApprovalRouteProps } from 'src/navigation/routeProps'

const BillPayNeedsApprovalAppRoute: AppRoute = {
  routeProps: billPayNeedsApprovalRouteProps,
  component: <BillPayNeedsApproval />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BillPayNeedsApprovalAppRoute
